<template>
  <!-- end of row -->
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <data-table :edit-item="editItem" :now="true" />
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import DataTableVue from "./components/DataTable.vue";

export default {
  name: "OnlineSessionIndex",
  components: {
    "data-table": DataTableVue,
  },
 data() {
    return {
      newItem: {},
      
    };
  },
};
</script>
